import { render } from "./FaVirtualScroller.vue?vue&type=template&id=4ba1ebac&scoped=true"
import script from "./FaVirtualScroller.vue?vue&type=script&lang=js"
export * from "./FaVirtualScroller.vue?vue&type=script&lang=js"

import "./FaVirtualScroller.vue?vue&type=style&index=0&id=4ba1ebac&scoped=true&lang=scss"

import exportComponent from "/home/farena/workspace/smt/smt_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba1ebac"]])

export default __exports__